import { Box, Button, ButtonGroup, Flex, HStack } from "@chakra-ui/react";
import { PriceMode } from "./schema";

const TicketTypeButtons = ({
  priceMode,
  onSelect,
  loading = false,
}: {
  onSelect: (mode: PriceMode) => void;
  loading: boolean;
  priceMode: PriceMode;
}) => {
  return (
    <HStack>
      <Box bg="gray.100" p="1" borderRadius="lg" w="fit-content">
        <Flex
          position="relative"
          w="200px"
          h="48px"
          borderRadius="8px"
          overflow="hidden"
        >
          <Box
            position="absolute"
            top={0}
            left={0}
            w="50%"
            h="100%"
            bg="white"
            borderRadius="8px"
            boxShadow="sm"
            transition="transform 300ms ease-in-out"
            transform={`translateX(${
              priceMode === PriceMode.TIERED_ALLOCATION ? "100%" : "0%"
            })`}
          />
          <Button
            variant="ghost"
            h="48px"
            flex="1"
            _hover={{
              backgroundColor: "transparent",
            }}
            transition="all 0.2s ease-in-out"
            disabled={loading}
            color="gray.700"
            onClick={() => onSelect(PriceMode.SINGLE)}
          >
            Basic
          </Button>
          <Button
            variant="ghost"
            h="48px"
            flex="1"
            disabled={loading}
            _hover={{
              backgroundColor: "transparent",
            }}
            transition="all 0.2s ease-in-out"
            color="gray.700"
            onClick={() => onSelect(PriceMode.TIERED_ALLOCATION)}
          >
            Tiered
          </Button>
        </Flex>
      </Box>
    </HStack>
  );
};

export default TicketTypeButtons;
